module.exports = __webpack_public_path__ + "30a3196aa470545264658f406707437b.svg";